module.exports = __webpack_public_path__ + "static/img/14000314.0eb264b9.png";